// Central SEO metadata map — source: client SEO doc (Jul 2026).
// Keys are exact route paths. SeoManager falls back to DEFAULT_META
// for any route not listed here.

export const SITE_URL = "https://niecce.education";

export const DEFAULT_META = {
  mainKeyword: "Teacher Training Institute in Bangalore",
  title: "Best Teacher Training Institute in Bangalore | NIECCE",
  description:
    "Discover NIECCE, a leading teacher training institute in Bangalore offering Nursery, Montessori and Primary Teacher Training courses with practical learning and career support.",
  keywords: [
    "Montessori Training in Bangalore",
    "nursery teacher training in Bangalore",
    "Primary Teacher Training in Bangalore",
    "Primary Education Course in Bangalore",
  ],
};

export const ROUTE_META = {
  "/": {
    mainKeyword: "Teacher Training Institute in Bangalore",
    title: "Best Teacher Training Institute in Bangalore | NIECCE",
    description:
      "Discover NIECCE, a leading teacher training institute in Bangalore offering Nursery, Montessori and Primary Teacher Training courses with practical learning and career support.",
    keywords: [
      "Montessori Training in Bangalore",
      "nursery teacher training in Bangalore",
      "Primary Teacher Training in Bangalore",
      "Primary Education Course in Bangalore",
    ],
  },
  "/about": {
    mainKeyword: "Primary Teacher Training",
    title: "NIECCE Teacher Training Institute | About Us",
    description:
      "Learn about NIECCE teacher training, offering Montessori teacher training programs, early childhood care courses, and pre-primary teaching education.",
    keywords: [
      "pre-primary teaching",
      "early childhood care course",
      "Montessori teacher training programs",
      "early childhood course",
    ],
  },
  "/courses": {
    mainKeyword: "Teacher Training Courses",
    title: "Teacher Training Courses in Bangalore | NIECCE",
    description:
      "Explore teacher training courses including Montessori, nursery teacher training, pre-primary, and primary teacher training programs at NIECCE.",
    keywords: [
      "Montessori course",
      "pre-primary training course",
      "nursery teacher training institutes",
      "primary teacher training course",
    ],
  },
  "/alumni": {
    mainKeyword: "Teacher Training Alumni",
    title: "Teacher Training Alumni Success Stories | NIECCE",
    description:
      "Discover NIECCE teacher training alumni achievements, excellence awards, and inspiring success stories from our nursery teacher training graduates.",
    keywords: [
      "teacher achievements",
      "education institute alumni",
      "alumni excellence awards teachers",
      "nursery teacher training alumni",
    ],
  },
  "/events": {
    mainKeyword: "Montessori Teacher Training Near Me",
    title: "Montessori Teacher Training Near Me | NIECCE Events",
    description:
      "Stay updated with NIECCE events, workshops, teacher training programs, Montessori training, and pre-primary education activities.",
    keywords: [
      "pre-primary course events",
      "teacher training institute",
      "primary education course",
      "Montessori training near me",
    ],
  },
  "/contact": {
    mainKeyword: "Teacher Training Course in Bangalore",
    title: "Teacher Training Course in Bangalore | Contact NIECCE",
    description:
      "Contact NIECCE for nursery teacher training, Montessori training centre, preschool teacher training, admissions, and course enquiries.",
    keywords: [
      "nursery teacher training course near me",
      "preschool teacher training near me",
      "nursery teacher training centre",
      "Montessori training centre near me",
    ],
  },
  "/awards": {
    mainKeyword: "NIECCE Teacher Training Course",
    title: "NIECCE Teacher Training Course Awards & Recognition",
    description:
      "Explore awards and achievements earned by NIECCE for excellence in teacher training, Montessori education, and teaching courses.",
    keywords: ["teaching courses", "Montessori training near me"],
  },
  "/partner": {
    mainKeyword: "NIECCE Teacher Training",
    title: "NIECCE Teacher Training Partners & Collaborations",
    description:
      "Learn about NIECCE's education partners supporting teacher certification, Montessori teacher training courses, and teaching programs.",
    keywords: [
      "teaching course",
      "teacher certification",
      "Montessori teacher training course",
    ],
  },
  "/competitions": {
    mainKeyword: "NIECCE Teacher Training Course",
    title: "NIECCE Teacher Training Course Competitions",
    description:
      "Participate in NIECCE competitions designed for teacher training students, nursery teacher training learners, and future educators.",
    keywords: [
      "training teacher course",
      "teacher training institutes near me",
      "nursery teacher training course",
    ],
  },
  "/course/ptt-course": {
    mainKeyword: "Primary Teaching",
    title: "Primary Teaching Course in Bangalore | NIECCE",
    description:
      "Enroll in NIECCE's primary teaching course with pre-primary teacher training and nursery teacher training for aspiring educators.",
    keywords: [
      "nursery teacher training course",
      "pre-primary teacher course",
    ],
    courseSchema: {
      name: "Primary Teacher Training (PTT) Course",
      description:
        "Primary teaching course with pre-primary teacher training and nursery teacher training for aspiring educators.",
    },
  },
  "/course/results": {
    mainKeyword: "Training Courses for Teachers",
    title: "Training Courses for Teachers Results | NIECCE",
    description:
      "View NIECCE training course results for Montessori, pre-primary teacher training, and nursery teacher training programs.",
    keywords: [
      "Montessori training near me",
      "pre-primary teacher training course",
      "Montessori training course details",
    ],
  },
  "/course/admission": {
    mainKeyword: "Teacher Teaching Admission",
    title: "Teacher Training Admission | Apply at NIECCE",
    description:
      "Apply for teacher training admission at NIECCE. Join Montessori, nursery teacher training, and teacher training programs today.",
    keywords: [
      "nursery teacher training admission",
      "teacher training institute",
      "teacher training programs admission",
    ],
  },
  "/course/ntt-mttcourse": {
    mainKeyword: "Nursery Teacher Training",
    title: "Nursery Teacher Training Course | NTT & MTT | NIECCE",
    description:
      "Join NIECCE's nursery teacher training course with NTT and Montessori teacher training programs for successful teaching careers.",
    keywords: [
      "nursery teacher training course",
      "nursery teacher training course near me",
      "NTT nursery teacher training",
    ],
    courseSchema: {
      name: "Nursery & Montessori Teacher Training (NTT/MTT) Course",
      description:
        "Nursery teacher training course with NTT and Montessori teacher training programs for successful teaching careers.",
    },
  },
  "/terms-conditions": {
    mainKeyword: "Montessori Teacher Training Course",
    title: "Montessori Teacher Training Course | Terms & Conditions",
    description:
      "Read NIECCE's terms and conditions for Montessori teacher training courses, nursery teacher training, and pre-primary teacher programs.",
    keywords: [
      "nursery teacher training",
      "Montessori training course",
      "pre-primary teacher training course",
    ],
  },
  "/privacypolicy": {
    mainKeyword: "Montessori Teacher Training",
    title: "Montessori Teacher Training | Privacy Policy | NIECCE",
    description:
      "Read NIECCE's privacy policy for Montessori training courses, NTT nursery teacher training, and online teacher training programs.",
    keywords: [
      "Montessori training course",
      "NTT nursery teacher training",
      "teacher training courses online",
    ],
  },
  "/refund-policy": {
    mainKeyword: "Teacher Training",
    title: "Teacher Training Refund Policy | NIECCE",
    description:
      "Learn about NIECCE's refund policy for teacher training, Montessori training courses, and primary teacher training programs.",
    keywords: [
      "primary teaching",
      "primary teacher training course",
      "Montessori training course",
    ],
  },
  "/apply": {
    mainKeyword: "Nursery Teacher Training Course Admission",
    title: "Nursery Teacher Training Course Admission | Apply Now",
    description:
      "Apply online for nursery teacher training course admission, Montessori teacher training admission, and teacher education programs.",
    keywords: [
      "Montessori teacher training admission",
      "nursery teacher training admission",
      "nursery teacher training course",
    ],
  },
  "/admission-process": {
    mainKeyword: "Montessori Teacher Training Course Process",
    title: "Montessori Teacher Training Course Admission Process",
    description:
      "Understand the NIECCE admission process for Montessori teacher training, nursery teacher training, and online pre-primary teacher courses.",
    keywords: [
      "Montessori teacher training process",
      "nursery teacher training process",
      "online nursery teacher training process",
      "pre-primary teacher course process",
    ],
  },
};

// Route prefixes that must not be indexed by search engines.
export const NOINDEX_PREFIXES = [
  "/login",
  "/signup",
  "/admin",
  "/teacher",
  "/student",
];
